var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.hubSpotUrl)?_c('b-link',{attrs:{"href":_vm.hubSpotUrl,"target":"_blank"}},[_vm._v("\n\tOpen HubSpot\n")]):_c('p',{staticClass:"m-0"},[_vm._v("No HubSpot ID")])}
var staticRenderFns = []

export { render, staticRenderFns }